import { i18next } from '@frontend/i18n';
import { useTranslationTokens } from '@frontend/i18n-tokens';
import { IconName } from '@frontend/icons';
import { ChipVariants } from '@frontend/design-system';
import type { AvailabilityMode } from '../../../components/availability/availability-form/types';

type TranslationTokens = ReturnType<typeof useTranslationTokens>;

export const getAvailabilityRuleTypes = (
  tokens: TranslationTokens
): Record<
  'operatory' | 'provider',
  {
    id: AvailabilityMode;
    name: string;
    description: string;
    icon: IconName;
    iconVariant: ChipVariants;
    iconTitle: string;
  }
> => ({
  operatory: {
    id: 'OPERATORY',
    name: i18next.t('Organize by Treatment Rooms', { ns: 'schedule-settings' }),
    description: i18next.t(
      'Organize schedules by treatment rooms and {{operatories}}. Best for offices where rooms are shared by multiple providers',
      { operatories: tokens.operatories, ns: 'schedule-settings' }
    ),
    icon: 'department',
    iconVariant: 'eggplant',
    iconTitle: tokens.operatory,
  },
  provider: {
    id: 'PROVIDER',
    name: i18next.t('Organize by Providers', { ns: 'schedule-settings' }),
    description: i18next.t(
      'Organize schedules by individual providers. Best for practices where each provider has their own dedicated room or flexible room usage.',
      { ns: 'schedule-settings' }
    ),
    icon: 'user', // TODO: Replace user icon with provider icon once available in design system
    iconVariant: 'seaweed',
    iconTitle: i18next.t('Provider', { ns: 'schedule-settings' }),
  },
});

export const getAvailabilityRuleTypeOptions = (tokens: TranslationTokens) => {
  const availabilityRuleTypes = getAvailabilityRuleTypes(tokens);
  return Object.values(availabilityRuleTypes);
};
